import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import CoursesPic from "../../../images/BasicQR.png";

const CoursesPicContBQR = () => {
  return (
    <div className="QL__PG__PGAboutUsSec">
      <Container>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <div className="QL__Sec__PGAboutUsmsg">
              <h1 className="HeadingAll">Basic Qur'an Reading</h1>
              <p className="pt-3">
                With LearnQuranQuick, learning and reading about Quran are easy.
                With the help of our experienced tutors, you will get to grasp
                the basic concepts of Islam in an intriguing manner.
                {/* Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergr.
                <br />
                <br />
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et
                <br />
                <br />
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum.
                <br />
                <br />
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergr. justo
                duo dolores et ea rebum. Stet clita kasd gubergr. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergr. justo
                duo dolores et ea rebum. Stet clita kasd gubergr.
                */}
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={CoursesPic} alt="image" />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default CoursesPicContBQR;
